import { isSalesCountryLocale } from "@/config/locale";

export interface AuthFailure {
	code?: string | null;
	field?: string | null;
	message?: string | null;
}
export type AuthErrorKey =
	| "invalidCredentials"
	| "expiredResetLink"
	| "passwordMinLength"
	| "invalidEmail"
	| "enterEmailFirst"
	| "enterPassword"
	| "confirm.title";

/** Known domain codes keep their actionable meaning; arbitrary server text is never target-language copy. */
export function authErrorKey(error: AuthFailure, flow: "login" | "reset" | "register"): AuthErrorKey | null {
	const code = error.code?.toUpperCase();
	if (code === "ACCOUNT_NOT_CONFIRMED") return "confirm.title";
	if (code === "PASSWORD_TOO_SHORT") return "passwordMinLength";
	if (
		flow === "reset" &&
		["INVALID_TOKEN", "JWT_INVALID_TOKEN", "JWT_SIGNATURE_EXPIRED", "JWT_DECODE_ERROR"].includes(code ?? "")
	)
		return "expiredResetLink";
	if (
		flow === "reset" &&
		error.field === "token" &&
		["INVALID", "NOT_FOUND", "REQUIRED"].includes(code ?? "")
	)
		return "expiredResetLink";
	if (flow === "login" && ["INVALID_CREDENTIALS", "INVALID_PASSWORD"].includes(code ?? ""))
		return "invalidCredentials";
	if (error.field === "email" && code === "INVALID") return "invalidEmail";
	if (error.field === "email" && code === "REQUIRED") return "enterEmailFirst";
	if (error.field === "password" && code === "REQUIRED") return "enterPassword";
	return null;
}
export function localizedAuthError(
	locale: string,
	error: AuthFailure | undefined,
	flow: "login" | "reset" | "register",
	translate: (key: AuthErrorKey) => string,
	fallback: string,
): string {
	if (!isSalesCountryLocale(locale)) return error?.message || fallback;
	const key = error && authErrorKey(error, flow);
	return key ? translate(key) : fallback;
}
